var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.value.name))]),_vm._t("default"),_c('a',{attrs:{"href":_vm.$voidHref},on:{"click":_vm.loadData}},[_vm._v("🔄 Refresh Data")]),_c('BasicTableComponent',{attrs:{"list":_vm.list,"formatters":_vm.listFormatters,"titles":_vm.listTitles}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }